import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { FwBadgeModule, FwIconModule, FwPopoverModule, FwTooltipModule } from '@flywheel-io/vision';

import { DirectivesModule } from '../common/directives.module';
import { ContainerAttachmentsService } from '../containers/attachments/container-attachments.service';
import { MaterialModule } from '../material.module';
import { AnnotationListComponent } from '../sessions/annotation-list/annotation-list.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { FileActionsComponent } from './file-actions/file-actions.component';
import { FileInfoDialog } from './file-info-dialog/file-info-dialog.component';
import { FileVersionBadgeComponent } from './file-version-badge/file-version-badge.component';
import { ConfirmRestoreDialog } from './file-version-dialog/confirm-restore-dialog.component';
import { FileVersionDialog } from './file-version-dialog/file-version-dialog.component';
import { InfoEditComponent } from './info-edit/info-edit.component';
import { InfoPropertyComponent } from './info-edit/info-property.component';

@NgModule({
  imports: [
    CdkMenuModule,
    CommonModule,
    DirectivesModule,
    FormsModule,
    FwIconModule,
    FwTooltipModule,
    FwPopoverModule,
    FwBadgeModule,
    MatDialogModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
    AnnotationListComponent,
],
  exports: [
    FileActionsComponent,
    FileVersionBadgeComponent,
    InfoEditComponent,
  ],
  declarations: [
    ConfirmRestoreDialog,
    FileActionsComponent,
    FileInfoDialog,
    FileVersionBadgeComponent,
    FileVersionDialog,
    InfoEditComponent,
    InfoPropertyComponent,
  ],
  providers: [
    ContainerAttachmentsService,
  ],
})
export class FileModule { }
